/**
 * A deck with no texts (handoff §8): a dashed placeholder box, which is the one
 * legitimate use of a dashed border (nothing is there yet). Tile, title, copy and
 * a secondary «Добавить текст», which opens the flow with this deck preset.
 */
import { FileText, Plus } from 'lucide-react'
import { useLocale } from '../../i18n/context'
import { SecondaryPill } from './ui'

export default function DeckTextsEmpty({ onAdd }: { onAdd: () => void }) {
  const { tr } = useLocale()
  const t = tr.deckTexts
  return (
    <div
      data-testid="deck-texts-empty"
      style={{
        padding: 20, borderRadius: 16, border: '1px dashed var(--border)',
        display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 12,
        fontFamily: 'var(--font-ui)',
      }}
    >
      <span aria-hidden style={{
        width: 40, height: 40, borderRadius: 8, background: 'var(--bg-secondary)', color: 'var(--text-secondary)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <FileText size={20} />
      </span>
      <p style={{ margin: 0, fontSize: 15, fontWeight: 600, color: 'var(--text-primary)' }}>{t.emptyTitle}</p>
      <p style={{ margin: 0, fontSize: 13, lineHeight: 1.5, color: 'var(--text-secondary)' }}>{t.emptyBody}</p>
      <SecondaryPill onClick={onAdd}>
        <Plus size={16} aria-hidden />
        {t.addText}
      </SecondaryPill>
    </div>
  )
}
